const usuarioAltaOrdenInitialState = {
  usuarioAltaOrden: {
    data: [],
    loading: false,
    error: false,
    estado: null,
  },
};

export default usuarioAltaOrdenInitialState;
